import { formBuilderData } from "src/app/helper/interface/response";

export const INVOICE_ADD_LIST_Dashboard: formBuilderData[] = [
  {
    colName: 'doctor_fk_id',
    title: 'Doctor Name',
    type: 'select',
    col_size: 12,
    apiTblName: 'doctor',
    selectKeyName: 'fname',
    selectPrimaryKey: 'user_id',
    validator: [{ name: 'required' }],
    event: { name: 'change', isCallback: true }
  },
  // {
  //   colName: 'patient_fk_id',
  //   title: 'Patient',
  //   col_size: 12,
  //   type: 'AUTOCOMPLETE',
  //   apiTblName: 'patient',
  //   selectKeyName: 'f_name',
  //   selectPrimaryKey: 'id',
  //   apiFunName: 'search',
  //   validator: [{ name: 'required', error: ' ' }],
  //   autoSearch: {
  //     titleKey: 'f_name',
  //     selectFieldKeys: ['patient_id', 'f_name'],
  //     separatorText: ' _',
  //   },
  // },
];
